import React, { memo, useEffect, useRef, useState, useCallback, useLayoutEffect } from "react";
import stylesPc from "./VideoPage.module.css";
import stylesSp from "./VideoPage_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import {
    // incrementVideoViewCount,
    AddViewingHistory,
    loadVideoStarted,
    ResetVideo,
    ResetVideos,
    UpdateVideoStatistics,
} from "../../../common/video/VideoActions";
import VideoPlayer from "./player/VideoPlayer";
import VideoMetaDataPanel from "./metaData/VideoInfoPanel";
import VideoSuggestionsPanel from "./suggestions/VideoSuggestionsPanel";
import VideoMenu from "../../../common/components/videoMenu/VideoMenu";
import { CircularProgress, IconButton } from "@material-ui/core";
import VideoDocument from "../../../pages/vod/Common/VideoDocument";
import { ResetUserVideos } from "../../../common/homePage/HomePageActions";
import VideoPlayerWithSubs from "../../../pages/vod/video/VideoPlayerWithSubs";
import Crop169Icon from "@material-ui/icons/Crop169";
import ViewCompactOutlinedIcon from "@material-ui/icons/ViewCompactOutlined";
import ViewStreamOutlinedIcon from "@material-ui/icons/ViewStreamOutlined";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { ConvertCaptionToVtt } from "../../../utils/LogicUtils";
import { CheckFileType, makeTagStr } from "../../../utils/ObjectUtils";
import SlideViewer from "./SlideViewer";
import { timestampStringToSeconds } from "../../../common/video/util/videoTimeStrings";
import { useInitFlag } from "../../../components/function/useInitFlag";
import VideoCommentPanel from "./comments/VideoCommentPanel";
import { t } from "i18next";
//import TwoSplitVideoPlayer from "./TwoSplitVideoPlayer";

// 10秒ごとに視聴時間を記録する
const VIDEO_TIME_UPDATE_INTERVAL_MS = 1000;
// 視聴数カウント条件
const VIEW_COUNT_MINIMUM_WATCHED_TIME_MS = 2000;

// TODO this component has grown far too big
function VideoPage() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const { userInfo, isRerunSTT } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
        isRerunSTT: state.exVideo.caption.isRerunSTT,
        videoOption: state.exVideo.videoOption,
    }));
    const videoRef = useRef<HTMLVideoElement>(null);

    const dispatch = useDispatch();
    // const history = useHistory();
    const match = useRouteMatch<{ id: string }>();
    const location = useLocation<{ time: number }>();

    // const videos = useSelector(({video}: AppState) => video.videos);
    const { video, isResetVideo } = useSelector(({ video }: AppState) => video);

    const [videoId, setVideoId] = useState<number>();
    // const [video, setVideo] = useState<Video | undefined>();

    const [hasUpdatedViewCount, setHasUpdatedViewCount] = useState<boolean>(false);
    const [currentVideoTimeMs, setCurrentVideoTimeMs] = useState<number>(
        videoRef.current?.currentTime || 0
    );
    const [currentTime, ChangeCurrentTime] = useState(0);

    const [msg, setMsg] = React.useState<string>("");
    // 編集中のチェックフラグ
    const [isEditModalOpen, setEditModalOpen] = useInitFlag();

    const closeMsg = () => {
        setMsg("");
    };

    // 画面遷移を監視
    const history = useHistory();
    history.listen((locationState) => {
        if (locationState.pathname !== location.pathname && video) {
            // リセット関連データ
            dispatch(ResetUserVideos());
            dispatch(ResetVideos());
            dispatch(ResetVideo());
        }
    });

    const [viewPattern, SwitchViewPattern] = useState(1);
    const ClickSwitchViewButton = (pattern: number) => {
        SwitchViewPattern(pattern);
    };

    useEffect(() => {
        if (video && video.viewingActivities.length > 0) {
            setCurrentVideoTimeMs(video?.viewingActivities[0].progressMillis);
        } else {
            setCurrentVideoTimeMs(0);
        }
    }, [video]);

    // ビデオ詳細情報取得（STTを含む）
    useEffect(() => {
        const { id } = match.params;
        const videoId = parseInt(id, 10);

        setVideoId(videoId);
        if (userInfo && isResetVideo) dispatch(loadVideoStarted(videoId, userInfo.id));
    }, [match, dispatch, userInfo, isResetVideo, history]);

    // キーコードを判定して該当処理を呼び出す
    const keyDownFun = (event: any) => {
        const active = document.activeElement;
        if (videoRef.current && !isEditModalOpen && active !== videoRef.current) {
            switch (event.keyCode) {
                case 32:
                    if (videoRef.current.paused) {
                        videoRef.current.play();
                    } else {
                        videoRef.current.pause();
                    }
                    event.preventDefault();
                    break;
            }
        }
    };

    // 画面表示パターン
    useEffect(() => {
        if (video?.slideFlg) {
            SwitchViewPattern(2);
        } else {
            SwitchViewPattern(1);
        }
        if (video) {
            UpdateTrack(ConvertCaptionToVtt("subtitles", video.captions));
        }
    }, [video]);

    // 字幕表示切り替え機能
    const [isActiveSubs, ChangeSubsActivate] = useState(false);
    const [track, UpdateTrack] = useState("");

    // 10秒ごとに視聴時間を記録する
    const updateTimeAndViewCountStatus = useCallback(() => {
        if (videoRef.current?.currentTime) {
            ChangeCurrentTime(videoRef.current.currentTime * 1000);
            const newCurrentTimeS = Math.floor(videoRef.current.currentTime * 1000);
            const interval = newCurrentTimeS - currentVideoTimeMs;
            // 視聴ビデオの第2秒
            if (
                newCurrentTimeS >= VIEW_COUNT_MINIMUM_WATCHED_TIME_MS &&
                newCurrentTimeS < 3000 &&
                !hasUpdatedViewCount
            ) {
                setHasUpdatedViewCount(true);
                if (userInfo && video) {
                    // APIが機能するまで一旦コメントアウト
                    // dispatch(incrementVideoViewCount(String(userInfo.id), Number(video.id)));
                    dispatch(AddViewingHistory(userInfo.id, video.id, newCurrentTimeS));
                    dispatch(
                        UpdateVideoStatistics(
                            Number(userInfo.id),
                            video.id,
                            makeTagStr(video.tags),
                            video.title,
                            video.imageUrl,
                            interval,
                            true
                        )
                    );
                }
            }
            // 視聴ビデオの10秒間隔
            if (newCurrentTimeS > 3000 && interval >= 10000) {
                if (userInfo && video) {
                    dispatch(AddViewingHistory(userInfo.id, video.id, newCurrentTimeS));
                    dispatch(
                        UpdateVideoStatistics(
                            Number(userInfo.id),
                            video.id,
                            makeTagStr(video.tags),
                            video.title,
                            video.imageUrl,
                            interval,
                            false
                        )
                    );
                }

                setCurrentVideoTimeMs(newCurrentTimeS);
                setHasUpdatedViewCount(true);
            }
            // ビデオ進捗バーをクリック時
            if (interval < 0) {
                setCurrentVideoTimeMs(newCurrentTimeS);
                if (userInfo && video) {
                    dispatch(AddViewingHistory(userInfo.id, video.id, newCurrentTimeS));
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, userInfo, videoRef, video, currentVideoTimeMs, hasUpdatedViewCount]);

    // 10秒ごとのループを設定
    useEffect(() => {
        const intervalId = setInterval(updateTimeAndViewCountStatus, VIDEO_TIME_UPDATE_INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, [updateTimeAndViewCountStatus]);

    // ビデオ再生停止
    useEffect(() => {
        videoRef.current?.addEventListener("pause", () => {
            const stopVideoTimeMS = videoRef.current?.currentTime;
            if (video && userInfo && stopVideoTimeMS) {
                setCurrentVideoTimeMs(Math.floor(stopVideoTimeMS * 1000));
                dispatch(
                    AddViewingHistory(userInfo.id, video.id, Math.floor(stopVideoTimeMS * 1000))
                );
            }
        });

        // 字幕表示切り替え
        videoRef.current?.textTracks.addEventListener("change", () => {
            if (videoRef.current?.textTracks[0].mode === "showing") {
                ChangeSubsActivate(true);
            } else {
                ChangeSubsActivate(false);
            }
        });

        // ビデオ進捗バーをクリック時
        videoRef.current?.addEventListener("seeking", () => {
            if (videoRef.current) {
                setCurrentVideoTimeMs(videoRef.current.currentTime * 1000);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, videoRef.current]);

    //再生履歴
    useLayoutEffect(() => {
        if (location.search === "") {
            if (!location.state || !location.state.time) {
                if (video && video.viewingActivities.length > 0) {
                    const progressMillis = video.viewingActivities[0].progressMillis;
                    if (progressMillis === video.durationMillis) {
                        if (videoRef.current) videoRef.current.currentTime = 0;
                        ChangeCurrentTime(0);
                    } else {
                        if (videoRef.current)
                            videoRef.current.currentTime = Math.floor(progressMillis / 1000);
                        ChangeCurrentTime(progressMillis / 1000);
                    }
                }
                return;
            }
        } else {
            const time = location.search.substr(6);
            const currentTime = timestampStringToSeconds(time);
            if (videoRef.current) {
                videoRef.current.currentTime = Number(currentTime);
                ChangeCurrentTime(Number(currentTime));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, dispatch, video?.viewingActivities, videoRef.current]);

    const [isUnderlKeyBorardControl, setIsUnderlKeyBorardControl] = useState<boolean>(true);
    useEffect(() => {
        document.addEventListener("keydown", keyDownFun);
        if (!isUnderlKeyBorardControl) {
            document.removeEventListener("keydown", keyDownFun);
        }
        return () => {
            document.removeEventListener("keydown", keyDownFun);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [[], videoRef.current, isUnderlKeyBorardControl]);

    // ページから離れる際に、再生時間更新する。
    useEffect(() => {
        return history.listen(() => {
            if (userInfo && video && videoRef.current) {
                const newCurrentTimeS = Math.floor(videoRef.current.currentTime * 1000);
                const interval = newCurrentTimeS - currentVideoTimeMs;
                dispatch(AddViewingHistory(userInfo.id, video.id, newCurrentTimeS));
                dispatch(
                    UpdateVideoStatistics(
                        Number(userInfo.id),
                        video.id,
                        makeTagStr(video.tags),
                        video.title,
                        video.imageUrl,
                        interval,
                        true
                    )
                );
            }
            dispatch(ResetVideo());
        });
        // eslint-disable-next-line
    }, [history, video]);

    if (!video || isRerunSTT) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    if (!video.id) {
        return (
            <div className={styles.noContent}>
                <h3>{t("Videoへのアクセス権がないため、視聴できません")}</h3>
            </div>
        );
    }

    return (
        <>
            {CheckFileType(video.fileName, video.fileName) !== "pdf" ? (
                <>
                    <div className={styles.switchViewButton}>
                        {video?.slideFlg && (
                            <div className={styles.switchViewPatternButtonGroup}>
                                <IconButton onClick={() => ClickSwitchViewButton(1)}>
                                    <Crop169Icon
                                        style={{
                                            color:
                                                viewPattern === 1
                                                    ? "var(--studio-btn-bg)"
                                                    : "var(--gray-85)",
                                        }}
                                    />
                                </IconButton>
                                <IconButton onClick={() => ClickSwitchViewButton(2)}>
                                    <ViewStreamOutlinedIcon
                                        style={{
                                            color:
                                                viewPattern === 2
                                                    ? "var(--studio-btn-bg)"
                                                    : "var(--gray-85)",
                                        }}
                                    />
                                </IconButton>
                                <IconButton
                                    onClick={() => ClickSwitchViewButton(3)}
                                    style={{ transform: "rotate(-180deg)", scale: "1, -1" }}
                                >
                                    <ViewCompactOutlinedIcon
                                        style={{
                                            color:
                                                viewPattern === 3
                                                    ? "var(--studio-btn-bg)"
                                                    : "var(--gray-85)",
                                        }}
                                    />
                                </IconButton>
                            </div>
                        )}
                    </div>

                    <div className={styles.root}>
                        {isActiveSubs ? (
                            <VideoPlayerWithSubs
                                video={video}
                                videoRef={videoRef}
                                currentVideoTimeMs={currentVideoTimeMs}
                                track={track}
                                setEditModalOpen={setEditModalOpen}
                            />
                        ) : (
                            <VideoPlayer
                                video={video}
                                videoRef={videoRef}
                                currentVideoTimeMs={currentTime}
                                setEditModalOpen={setEditModalOpen}
                                setMsg={setMsg}
                            />
                        )}

                        <div className={styles.menu}>
                            <VideoMenu
                                video={video}
                                videoId={videoId ? videoId : 0}
                                setMsg={setMsg}
                            />
                        </div>

                        <div className={styles.meta}>
                            <div className={styles.metaLeft}>
                                <VideoMetaDataPanel video={video} />

                                {video.extraMaterials.length > 0 && (
                                    <div className={styles.materials}>
                                        <VideoDocument
                                            documentList={video.extraMaterials}
                                            contentType={"video"}
                                        />
                                    </div>
                                )}
                                <div className={styles.comments}>
                                    <VideoCommentPanel
                                        videoId={video.id}
                                        videoRef={videoRef}
                                        setIsUnderlKeyBorardControl={setIsUnderlKeyBorardControl}
                                    />
                                </div>
                            </div>
                            {videoId && (
                                <div className={styles.metaRight}>
                                    <VideoSuggestionsPanel videoId={video.id} />
                                </div>
                            )}
                        </div>

                        <PuiMessage
                            open={msg !== ""}
                            type="success"
                            title={t("登録に成功しました")}
                            detail={[
                                <PuiTypography key={msg} color="black">
                                    {msg}
                                </PuiTypography>,
                            ]}
                            duration={5000}
                            onClose={closeMsg}
                        />
                    </div>
                </>
            ) : (
                <SlideViewer />
            )}
        </>
    );
}

export default memo(VideoPage);
